import {Flex} from 'antd';
import {ReactElement} from 'react';

import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';

import {HistoryExpandableComment} from './history-expandable-comment';

type PropsType = {
    value: ReviewHistoryDataType['oldValue'];
};

export function HistoryCatalogEditComment(props: PropsType): ReactElement {
    const {value} = props;

    return (
        <Flex vertical>
            <HistoryExpandableComment value={value} />
        </Flex>
    );
}
